export var AddMode;
(function (AddMode) {
    AddMode["columns"] = "columns";
    AddMode["rows"] = "rows";
})(AddMode || (AddMode = {}));
export var JoinType;
(function (JoinType) {
    JoinType["LEFT"] = "left";
    JoinType["RIGHT"] = "right";
    JoinType["INNER"] = "inner";
    JoinType["ANTI"] = "anti";
    JoinType["OUTER"] = "outer";
})(JoinType || (JoinType = {}));
export var ExtraCharacterHandlingOptions;
(function (ExtraCharacterHandlingOptions) {
    ExtraCharacterHandlingOptions["append"] = "append";
    ExtraCharacterHandlingOptions["drop"] = "drop";
})(ExtraCharacterHandlingOptions || (ExtraCharacterHandlingOptions = {}));
//# sourceMappingURL=enums.js.map